export const isNil = (input: any) => [null, undefined].includes(input);
